import React, { useEffect, useState } from "react";
import "./index.scss";
// import { appDownload } from "@/utils/appDownload";
import { connect } from "react-redux";
import request from "@/utils/request";
import { appDownload } from "@/api";
import { Button, Icon, Toast } from "antd-mobile";
import { getLocationSearch, isIosOrA, isWeiXin } from "@/utils/utils";

const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});

const JoinFleetOk = (props) => {
  let { tenant } = props;
  let tenantTag = getLocationSearch().tenantTag;
  let { phone, type } = props.match.params;
  let [show, setShow] = useState(false);
  const initRequest = async () => {
    if (!isIosOrA() && isWeiXin()) {
      setShow(true);
      return;
    }
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      `${appDownload}?tenantTag=${tenantTag}&isIos=${!isIosOrA()}`
    );
    Toast.hide();
    if (res.data.data) {
      window.location.href = res.data.data;
      console.log(res.data.data);
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  useEffect(() => {
    document.title = "邀请您加入车队";
    return () => {
      document.title = "";
    };
  }, []);
  return (
    <div className="join-fleet-ok__box">
      {show ? (
        <div class="tips_page" onClick={() => setShow(false)}>
          <img src="https://yhyfiles.oss-cn-shanghai.aliyuncs.com/qm/share_arrow.png" />
          <span>点击屏幕右上角 ··· 按钮，在浏览器中打开下载</span>
        </div>
      ) : null}
      <h2>
        Hi！ {phone} <span>欢迎来到{tenant}</span>
      </h2>
      <div className="join-join-ok-info">
        <i className="iconfont icon-icon-"></i>
        {/* <span>完成首单即可获得奖励，车队成员都在等你哦</span> */}
        {type == "ERROR" ? (
          <span>加入车队失败</span>
        ) : (
          <span>加入车队成功，请下载APP查看车队详情</span>
        )}
      </div>
      <footer>
        <button
          onClick={initRequest}
          style={React.colorConfig ? React.colorConfig.buttonBg : {}}
        >
          前往下载APP
        </button>
      </footer>
    </div>
  );
};
export default connect(mapStateToProps)(JoinFleetOk);
